import { legacy_createStore as createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import rootReducer from './reduces'
const initialState = {
    tabs: [{path: '/layout/home', name: '工作台'}]
}
const configureStore = (preloadedState: any) => {
    return createStore(
        rootReducer, 
        preloadedState, 
        applyMiddleware(thunkMiddleware)
    )
}
const store = configureStore(initialState)
export default store
